import { Action } from "@frontend/ui-kit/Action";
import { IcCancelMOutline } from "@frontend/ui-kit/icons/IcCancelMOutline";
import { NavBar, NavBarRightSection } from "@frontend/ui-kit/NavBar";
import type { PropsWithChildren } from "react";

import styles from "./Modal.module.css";

type ModalProps = PropsWithChildren<{
    onClose: () => void;
}>;

export const Modal = ({ onClose, children }: ModalProps) => {
    return (
        <div className={styles.wrapper}>
            <ModalBackdrop onClose={onClose} />
            <div className={styles.modal}>
                <ModalHeader onClose={onClose} />
                <div className={styles.content}>{children}</div>
            </div>
        </div>
    );
};

type ModalHeaderProps = {
    onClose: () => void;
};

const ModalHeader = ({ onClose }: ModalHeaderProps) => {
    return (
        <div className={styles.header}>
            <NavBar
                renderRightSection={
                    <NavBarRightSection
                        actions={[
                            <Action key="close" icon={<IcCancelMOutline />} onClick={onClose} />,
                        ]}
                    />
                }
            />
        </div>
    );
};

type ModalBackdropProps = {
    onClose: () => void;
};

const ModalBackdrop = ({ onClose }: ModalBackdropProps) => {
    return (
        // biome-ignore lint/a11y/noStaticElementInteractions: modal backdrop click
        <div className={styles.backdrop} onClick={onClose} />
    );
};
